/**
 * PrimitiveFlowEditor.tsx
 * 
 * This is just a wrapper that imports and configures the unified FlowEditor
 * component with isPrimitive=true
 */
import { FlowEditor } from './FlowEditor';

export function PrimitiveFlowEditor() {
  return <FlowEditor isPrimitive={true} />;
}
